import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchDeleteCVCompanyRecords } from "./learningAPI";
import swal from 'sweetalert';
export interface DeleteCompanyRecordState {
  deleteCVCompanyRecords: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DeleteCompanyRecordState = {
    deleteCVCompanyRecords: [],
  status: "idle",
};

export const GetDeleteCVCompanyRecords = createAsyncThunk(
  "DeleteCVCompanyRecords/fetchDeleteCVCompanyRecords",
  async (data:any) => {
    const response = await fetchDeleteCVCompanyRecords(data);
    return response;
  }
);

export const DeleteCVCompanyRecordsSlice = createSlice({
  name: "DeleteCVCompanyRecords",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetDeleteCVCompanyRecords.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetDeleteCVCompanyRecords.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetDeleteCVCompanyRecords.fulfilled, (state, action) => {
        state.status = "idle";
        state.deleteCVCompanyRecords = action.payload;
        swal("Record delete success!",  "success");
        //window.location.reload();
      });
  },
});

export const {} = DeleteCVCompanyRecordsSlice.actions;

export const selectDeleteCVCompanyRecords = (state: RootState) => {
  return state.DeleteCVCompanyRecords.deleteCVCompanyRecords;
};

export default DeleteCVCompanyRecordsSlice.reducer;
